import { render, staticRenderFns } from "./ReOrder.vue?vue&type=template&id=b0ff9d60"
import script from "./ReOrder.vue?vue&type=script&lang=js"
export * from "./ReOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports